import { render, staticRenderFns } from "./UserDetailComponent.vue?vue&type=template&id=f0c7290e&scoped=true&"
import script from "./UserDetailComponent.vue?vue&type=script&lang=js&"
export * from "./UserDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailComponent.vue?vue&type=style&index=0&id=f0c7290e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c7290e",
  null
  
)

export default component.exports